import { DefaultRootState } from 'react-redux';
import { Dispatch, Middleware } from 'redux';

import { Action } from 'store/createReducer';

export const BATCH = 'BATCHING_ACTIONS';

export interface BatchAction {
    type: typeof BATCH;
    payload: Action[];
}

type RootReducer<S = unknown> = (state: S, action: Action) => S;

export interface BatchDispatch<A extends Action> extends Dispatch {
    <T extends A | A[]>(action: T): T;
}

export const batchActionCreator = (actions: Action[]): BatchAction => ({
    type: BATCH,
    payload: actions,
});

const isBatchAction = (action: Action): action is BatchAction => action.type === BATCH;

export const batchReducer =
    (rootReducer: RootReducer<DefaultRootState>) =>
    (state: DefaultRootState | undefined, action: Action | BatchAction): DefaultRootState => {
        if (!state) {
            throw new Error('no initial state');
        }
        if (isBatchAction(action)) {
            return action.payload.reduce((state: DefaultRootState, action: Action) => {
                try {
                    return rootReducer(state, action);
                } catch (e) {
                    return state;
                }
            }, state);
        }
        return rootReducer(state, action);
    };

const batchedMiddleware: Middleware =
    ({ dispatch }) =>
    (next) =>
    (action: Action | Action[]) => {
        if (Array.isArray(action)) {
            return dispatch(batchActionCreator(action));
        }

        return next(action);
    };

export default batchedMiddleware;
